import React from "react";
import FormLink from '../../../library/form/components/FormLink';
import FormROValue from '../../../library/form/components/FormROValue1';

const InvParentLinkRow = (props) => {
    const { formObject, rowKey } = props;

    // console.log("InvParentLinkRow",viewData);
    return (
        <div className="uiInlineFloat5 list-row">
            <div style={{ minHeight: "45px" }} className="uiBoxHeader uiContentCenter uiBorderRoundAll">
                <FormLink formObject={formObject} rowKey={rowKey} linkProp={{ target: "_blank" }} className="uiMainBlockClear uiColumnCenter uiLinkRow"
                    action={{ paramName: "rowContainer", actionId: "show" }} anchorStyle={{ minHeight: "45px" }}
                >
                    <div className="uiInfoBlock">
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "invDate" }} className='uiSpacerH5' />
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "descp" }} className='uiBold' />
                    </div>
                    <div className="uiInfoBlock">
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "invAmt" }} className='uiHighlightBlue' />
                    </div>
                    <div className="uiInfoBlock">
                    </div>
                </FormLink>
            </div>
        </div>
    )
}

export default InvParentLinkRow
